export default {"src":"/_next/static/media/emergency-logo.4d56a344.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};